<template>
    <div class="info-block">
        <h4>Tivo Admin is a full featured,premium bootstrap admin template</h4>
        <a href="javascript:void(0)" data-bs-original-title="" title="">tivoeducation.info/</a>
        <p>
            Tivo introduces a IELTS Coaching, TOEFL Coaching, GRE Coaching, GMAT
            Coaching, SAT Coaching in Surat.
        </p>
        <div class="star-ratings">
            <ul class="search-info">
                <li>
                    <ul class="rating">
                        <li><i class="icofont icofont-ui-rating"></i></li>
                        <li><i class="icofont icofont-ui-rating"></i></li>
                        <li><i class="icofont icofont-ui-rating"></i></li>
                        <li><i class="icofont icofont-ui-rating"></i></li>
                        <li><i class="icofont icofont-ui-rate-blank"></i></li>
                    </ul>
                </li>
                <li>4 stars</li>
                <li>590 votes</li>
                <li>Music</li>
            </ul>
        </div>
    </div>
    <div class="info-block">
        <h4>Koho Admin is a full featured,premium bootstrap admin template</h4>
        <a href="javascript:void(0)" data-bs-original-title="" title="">kohoeducation.info/</a>
        <p>
            Koho introduces a IELTS Coaching, TOEFL Coaching, GRE Coaching, GMAT
            Coaching, SAT Coaching in Surat.
        </p>
        <div class="star-ratings">
            <ul class="search-info">
                <li>
                    <ul class="rating">
                        <li><i class="icofont icofont-ui-rating"></i></li>
                        <li><i class="icofont icofont-ui-rating"></i></li>
                        <li><i class="icofont icofont-ui-rate-blank"></i></li>
                        <li><i class="icofont icofont-ui-rate-blank"></i></li>
                        <li><i class="icofont icofont-ui-rate-blank"></i></li>
                    </ul>
                </li>
                <li>2 stars</li>
                <li>590 votes</li>
                <li>Music</li>
            </ul>
        </div>
    </div>
    <div class="info-block">
        <nav aria-label="...">
            <ul class="pagination pagination-primary">
                <li class="page-item disabled">
                    <a class="page-link" href="javascript:void(0)" tabindex="-1">Previous</a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="javascript:void(0)">1</a>
                </li>
                <li class="page-item active">
                    <a class="page-link" href="javascript:void(0)">2 <span class="sr-only">(current)</span></a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="javascript:void(0)">3</a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="javascript:void(0)">Next</a>
                </li>
            </ul>
        </nav>
    </div>
</template>